const state = {
    deliveryPoints:[],
};

const getters = {
    deliveryPoints: state => state.deliveryPoints,
};

const actions = {
    getDeliveryPoints({commit, state}){
        axios.get('/api/admin/delivery/points').then((response) => {
            commit('setDeliveryPoints', response.data.data);
        })
    }
};

const mutations = {
    setDeliveryPoints(state, points){
        state.deliveryPoints = points;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
